import { RESET_STATE_RIKJANG } from "../constants";

export const initialState = {
  form_data: RESET_STATE_RIKJANG,
  rikjang_id: null,

  rikjang: {
    list: [],
    total_data: 0,
  },

  field_tarif: [],
  form_harga_tarif_beli: [],
  form_harga_tarif_jual: [],

  list_barang: [],
  list_jasa: [],
  list_fasilitas: [],
};

export const actions = {
  CHANGE_FORM_DATA: "CHANGE_FORM_DATA",
  CHANGE_RIKJANG_ID: "CHANGE_RIKJANG_ID",
  CHANGE_RIKJANG: "CHANGE_RIKJANG",

  CHANGE_LIST_BARANG: "CHANGE_LIST_BARANG",
  CHANGE_LIST_JASA: "CHANGE_LIST_JASA",
  CHANGE_LIST_FASILITAS: "CHANGE_LIST_FASILITAS",

  CHANGE_FORM_HARGA_TARIF_BELI: "CHANGE_FORM_HARGA_TARIF_BELI",
  CHANGE_FORM_HARGA_TARIF_JUAL: "CHANGE_FORM_HARGA_TARIF_JUAL",
  CHANGE_FIELD_TARIF: "CHANGE_FIELD_TARIF",
};
